var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftMenu = function SvgLeftMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#093451",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 25 25",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,18h25v2H0V18z M0,14h25v-2H0V14z M0,6v2h25V6H0z"
  })));
};
export { SvgLeftMenu as ReactComponent };